import { STAGE_LABELS_CUSTOM } from './customStage';

const titleCase = (v: string) => (v ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v);

export const CHIP_DIMENSIONS: { key: string; label: string; format?: (v: string) => string }[] = [
    { key: 'program', label: 'Program' },
    { key: 'batch_year', label: 'Batch' },
    { key: 'alma_mater_pride', label: 'Alma Mater Pride', format: titleCase },
    { key: 'marketability', label: 'Marketability', format: titleCase },
    { key: 'vibrancy', label: 'Vibrancy', format: titleCase },
    { key: 'date_from', label: 'From' },
    { key: 'date_to', label: 'To' },
    { key: 'search', label: 'Search' },
    { key: 'stage', label: 'Stage', format: (v) => STAGE_LABELS_CUSTOM[v] || v },
];
